export default __webpack_public_path__ + "static/media/plusCircle.fb90b126.svg";